export const REQUIRED_WEIGHT_MESSAGE = "Please enter your weight to calculate your daily protein target.";

export function parseWeightKg(weightKg) {
  const parsed = Number(weightKg);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function isValidWeightKg(weightKg) {
  return parseWeightKg(weightKg) > 0;
}

export function validateWeightKg(weightKg) {
  if (!String(weightKg ?? "").trim() || !isValidWeightKg(weightKg)) {
    return {
      valid: false,
      error: REQUIRED_WEIGHT_MESSAGE,
      weightKg: 0,
    };
  }

  return {
    valid: true,
    error: "",
    weightKg: parseWeightKg(weightKg),
  };
}

export function calculateProteinLimitFromWeight(weightKg) {
  const parsedWeight = parseWeightKg(weightKg);
  if (parsedWeight <= 0) return 0;

  return Math.round(parsedWeight * 1.2 * 10) / 10;
}
